export type Kind = 'offerta' | 'ordine' | 'ddt' | 'fattura';
export type Header = {
  id: string; tipo: Kind; numero: string; data: string; cliente_id: string;
  cliente_nome?: string; valuta: string; stato: string; stato_origine?: string;
  sorgente: string; chiave_esterna?: string; offerta_id?: string; note?: string;
  num_righe?: number; imponibile?: string; iva?: string; totale?: string;
};
export type Row = {
  id: string; chiave: string; codice?: string; descrizione: string; unita_misura: string;
  quantita: string; prezzo_unitario: string; sconto_percentuale: string; aliquota_iva: string;
  imponibile: string; quantita_utilizzata: string; quantita_prenotata: string;
  quantita_chiusa: string; quantita_residua: string; motivo_chiusura?: string;
  da_riconciliare: string; quantita_evasa_origine: string;
};
export type Detail = Header & {
  documenti_successivi?: Header[]; righe: Row[]; totale: string; imponibile: string; iva: string;
  stato_evasione?: string;
  legami: { id: string; origine: Header; destinazione: Header; quantita: string }[];
};
export const PAGE_SIZE = 20;
export const labels: Record<Kind, string> = { offerta: 'Offerte', ordine: 'Ordini', ddt: 'DDT', fattura: 'Fatture' };
export const singular: Record<Kind, string> = { offerta: 'Offerta', ordine: 'Ordine', ddt: 'DDT', fattura: 'Fattura' };
export const kinds = Object.keys(labels) as Kind[];
export const documentUrl = (doc: Header) => `/sales-documents/${doc.id}?type=${doc.tipo}`;
export const listUrl = (kind: Kind) => `/sales-documents?type=${kind}`;
export const money = (value: string | undefined, currency = 'EUR') => value == null ? '—' : Number(value).toLocaleString('it-IT', { style: 'currency', currency });
export const unitMoney = (value: string | undefined, currency = 'EUR') => value == null ? '—' : Number(value).toLocaleString('it-IT', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 4 });
export const quantity = (value: string | undefined) => value == null ? '—' : Number(value).toLocaleString('it-IT', { maximumFractionDigits: 4 });
export const dateLabel = (value: string) => new Date(`${value}T12:00:00`).toLocaleDateString('it-IT');
export const sourceLabel = (source: string) => ({ interno: 'Offertify', offertify: 'Offerta Offertify', mepa: 'Gestionale MEPA' }[source] || source);
export const stateLabel = (state?: string) => ({ bozza: 'Bozza', confermato: 'Confermato', annullato: 'Annullato', da_evadere: 'Da evadere', parzialmente_evaso: 'Parzialmente evaso', evaso: 'Evaso', chiuso_con_residuo: 'Chiuso con residuo', da_riconciliare: 'Pregresso da collegare' }[state || ''] || state || '');

export function clientReturnUrl(value: string | null, clientId: string): string | undefined {
  return value && ['offerte', 'ordini', 'ddt', 'fatture'].some(tab => value === `/clients/${clientId}?tab=${tab}`) ? value : undefined;
}
